const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;

export default CLIENT_ID;
